export enum ActiveControlOptions {
    SUBJECT = "subject",
    MESSAGE = "message",
}
